import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import Text from 'components/base/Text';
import { SPACES } from 'common/constants/sizes';

export const SummaryItemMoreContainer = styled(Flex)`
  flex-grow: 1;
  flex-basis: 0;
  max-width: 20rem;
`;

const SummaryItem = styled(Flex)`
  padding: 0 1rem 0.5rem 1.5rem;
  ${({ displayType }) =>
    displayType === 'more'
      ? `
    border-left: 1px solid ${getColor('botticelli')};
  `
      : `
    flex-grow: 1;
    flex-basis: 0;
    max-width: 20rem;
    &:not(:first-child) {
      border-left: 1px solid ${getColor('botticelli')};
    }
  `};
`;

export const MAX_NUM_OF_SUMMARY_TYPES = 6;

const SummaryItemBox = ({ displayType, typeColor, type, percents, total }) => {
  return (
    <SummaryItem direction='column' displayType={displayType}>
      <div
        style={{
          width: '0.8rem',
          height: '0.8rem',
          backgroundColor: typeColor
        }}
      ></div>
      <Text size='medium' pt={`${SPACES['small']}`} pb='0.3rem'>
        {type}
      </Text>
      <Text size='x-x-x-large' pb={`${SPACES['x-small']}`} weight='300'>
        {_.round(percents, 1)}%
      </Text>
      <Text size='small' color='shuttleGray'>
        {total}
      </Text>
    </SummaryItem>
  );
};

export default SummaryItemBox;
